<template>
  <b-modal ref="addItemModal"
           id="modal-edit-issue"
           title="Редактировать выпуск"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите название"
                        v-model="editForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-link">
        <b-form-input id="link"
                        type="text"
                        placeholder="Введите ссылку"
                        v-model="editForm.link"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-mass_media" label="Газета/журнал">
        <b-form-select id="mass_media"
                        type="text"
                        placeholder="Газета/журнал"
                        v-model="editForm.mass_media"
                        :options="groups"
                        required>

        </b-form-select>
      </b-form-group>
      <b-form-group id="form-title-vipusk-pic" label="Изображение"> 
        <picture-input ref="pictureInput" width="200" height="200" margin="8" accept="image/jpeg,image/png" size="10"
          :removable="true" :customStrings="{
          upload: '<h1>Перетащите изображение</h1>',
          drag: 'Перетащите изображение',
          change: 'Заменить фото',
          remove: 'Удалить фото',
        }">
        </picture-input>
      </b-form-group>
      <b-button type="submit" variant="success">Изменить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';
import PictureInput from 'vue-picture-input';

export default {
  components: {
    alertMsg,
    PictureInput
  },
  name: 'modalEdit',
  data() {
    return {
      editForm: {
        name: '',
        link: '',
        mass_media: '',
        image: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      groups: [],
    };
  },
  computed: {
    ...mapState({
      editing_item: state => state.issues.editing_item,
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    editItem(payload) {
      this.showAlert = false;
      const id = 'modal-edit-issue';
      const path = this.host + 'edit_issue';
      axios.post(path, payload, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('issue');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    take_groups() {
      this.showAlert = false;
      const path = this.host + 'take_medias';
      axios.post(path, {}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.groups = res.data.medias;
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = {
        'id' : this.editing_item.id,
        'name' : this.editForm.name,
        'link' : this.editForm.link,
        'mass_media' : this.editForm.mass_media,
        'image' : this.$refs.pictureInput.image,
        'image_name' : this.$refs.pictureInput.file.name
      };
      this.editItem(payload);
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-edit-issue');
      this.initForm();
    },
    initForm() {
      this.editForm.name = this.editing_item.name;
      this.editForm.link = this.editing_item.link;
      this.editForm.link = this.editing_item.image;
      this.groups.forEach(function(group) {
        if (group.text === this.editing_item.mass_media){
          this.editForm.mass_media = group.value;
        }
      },this);
    },
  },
  created() {
    this.take_groups();

  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-edit-issue'){
        this.initForm();
      }
    })
  },
};
</script>

<style scoped>

</style>
